import 'reflect-metadata';
import { jsonObject, jsonMember, toJson, TypedJSON, jsonArrayMember } from 'typedjson';

@jsonObject
@toJson
export class CropBox {
  @jsonMember public xMinNorm!: number;
  @jsonMember public yMinNorm!: number;
  @jsonMember public xMaxNorm!: number;
  @jsonMember public yMaxNorm!: number;
}

@jsonObject
@toJson
export class DetectionBox {
  @jsonMember public source!: string; // ex: 'sagemaker_objects', 'rekognition', 'safety_no_safety', ...

  @jsonMember public label!: string; // ex: 'Person', 'camion', ...
  @jsonMember({ constructor: Number }) public score!: number; // 0..100

  @jsonMember({ constructor: Number }) public xMinNorm!: number; // 0..1
  @jsonMember({ constructor: Number }) public yMinNorm!: number; // 0..1
  @jsonMember({ constructor: Number }) public xMaxNorm!: number; // 0..1
  @jsonMember({ constructor: Number }) public yMaxNorm!: number; // 0..1
}

@jsonObject
@toJson
export class Photo {
  @jsonMember public id!: string;
  @jsonMember public createdAt!: Date;
  @jsonMember public weekday!: number;
  @jsonMember public hour!: string;
  @jsonMember public key!: string;
  @jsonMember public cameraId!: string;
  @jsonMember public projectId!: string;
  @jsonMember public exposure?: number;
  @jsonMember public hdr?: boolean;
  @jsonMember public blueLevel?: number;
  @jsonMember public gainControl?: number;
  @jsonMember public sharpness?: number;
  @jsonMember public blurred?: boolean;
  @jsonMember public movement?: number;
  @jsonMember public score?: number;
  @jsonMember public motion?: number;
  @jsonMember public structure?: number;
  @jsonMember public keypoints?: number;
  @jsonMember public flow?: number;
  @jsonMember public orient?: number;
  @jsonMember({ constructor: Number })
  public maxDb?: number;

  // Compat : ancien nested si présent
  @jsonMember public motiondetect?: {
    score?: number;
    motion?: number;
    structure?: number;
    keypoints?: number;
    flow?: number;
    orient?: number;
  };
  @jsonMember detectedLabels?: { [label: string]: number };
  @jsonMember public safetyScore?: number;
  @jsonMember public housekeepingScore?: number;
  @jsonMember public safetyAnalysisJson?: string;

  @jsonArrayMember(DetectionBox)
  public detections: DetectionBox[] = [];

  get person(): number | undefined {
    return this.detectedLabels?.Person;
  }
  get goutte(): number | undefined {
    return this.detectedLabels?.goutte;
  }

  @jsonArrayMember(String)
  public cropKeys: string[] = [];

  @jsonArrayMember(String)
  public cropKeysNoSafety: string[] = [];

  @jsonArrayMember(CropBox)
  public cropBoxesNoSafety: CropBox[] = [];

  @jsonArrayMember(String)
  public cropKeysCar: string[] = [];

  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  @jsonMember public isSlowmotion: boolean = false;
  public isSelected = false;

  public get smallKey(): string {
    return `${this.key}-small`;
  }

  public get mediumKey(): string {
    return `${this.key}-medium`;
  }

  public get thumbnailKey(): string | undefined {
    return this.isSlowmotion ? `${this.key}-thumbnail` : undefined;
  }
}

export const serializer = new TypedJSON(Photo);

// eslint-disable-next-line max-classes-per-file
@jsonObject
@toJson
export class IframePhoto
  implements Pick<Photo, 'id' | 'createdAt' | 'key' | 'isSlowmotion' | 'smallKey' | 'mediumKey' | 'thumbnailKey'>
{
  @jsonMember
  public id!: string;
  @jsonMember
  public createdAt!: Date;
  @jsonMember
  public key!: string;
  @jsonMember
  public isSlowmotion!: boolean;

  public get smallKey(): string {
    return `${this.key}-small`;
  }

  public get mediumKey(): string {
    return `${this.key}-medium`;
  }

  public get thumbnailKey(): string | undefined {
    return this.isSlowmotion ? `${this.key}-thumbnail` : undefined;
  }
}

export const iframePhotoSerializer = new TypedJSON(IframePhoto);

// eslint-disable-next-line max-classes-per-file
@jsonObject
@toJson
export class PublicPhoto {
  @jsonMember id!: string;
  @jsonMember createdAt!: Date;
  @jsonMember photoId!: string;
  @jsonMember key!: string;
  @jsonMember putUrl?: string;
}
